import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Service } from './services.models';

export const BookingSelectServicesActions = createActionGroup({
  source: 'Booking Select Services',
  events: {
    'Load Services': emptyProps(),
    'Select Service': props<{ uuid: string }>(),
    'Unselect Service': props<{ uuid: string }>(),
    'Unselect All Services': emptyProps(),
  },
});

export const BookingSelectServicesApiActions = createActionGroup({
  source: 'Booking Select Services API',
  events: {
    'Load Success': props<{ services: Array<Service> }>(),
    'Load Failure': emptyProps(),
  },
});

export const BookingSessionStorageActions = createActionGroup({
  source: 'Booking Session Storage',
  events: {
    'Load Selected Services': emptyProps(),
    'Set Selected Services': props<{ selectedServices: Array<string> }>(),
  },
});
